<template>
    <div class="mainbgm">
        <div style=" height: 80vh;">
            <div style="height:120px;"><img src="@/assets/title.png" alt="" style="height: 40px;padding: 30px 60px;">
            </div>
            <div class="mainlogin">
                <div>
                    <h2>主数据管理平台</h2>
                    <h3>GHW International</h3>
                    <div style="margin-bottom:4px ">"Grow with customers" and look forward to</div>
                    <div>working together width more friends!</div>
                </div>
                <el-dialog title="设置密码" :visible.sync="dialogFormVisible" width="20%" height="300px"
                           :close-on-click-modal="false" @close="dialogClose">
                    <!--设置新密码-->
                    <el-form ref="formpwd" :model="formpwd" label-width="80px" class="setform"
                             style="padding: 35px 0px 20px;">
                        <el-form-item prop="vc_login">
                            <el-input v-model="formpwd.vc_login" placeholder="用户名"
                                      prefix-icon="el-icon-user" disabled></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="formpwd.password" placeholder="设置密码" type="password"
                                      prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                        <el-form-item prop="verifypwd">
                            <el-input v-model="formpwd.verifypwd" placeholder="确认密码" type="password"
                                      prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer" 　style="text-align: center;">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="getvalidate('formpwd')">保存</el-button>
                    </div>
                </el-dialog>
                <div class="loginform">
                    <div style="display: flex;justify-content: space-between;border-bottom: 1px solid #d6d4d4;">
                        <div class="usercode" @click="change(true,'formphone')" :class="{active:active==true}">帐号密码
                        </div>
                        <div class="phone" @click="change(false,'formlogin')" :class="{active:active==false}">手机验证</div>
                    </div>
                    <!--用户名登录-->
                    <el-form ref="formlogin" :model="formlogin" :rules="rules"
                             style="padding: 35px 0px 20px;position: relative"
                             v-show="temp">
                        <el-form-item prop="vc_login">
                            <el-input v-model="formlogin.vc_login" placeholder="用户名"
                                      prefix-icon="el-icon-user" :disabled="disabled"></el-input>
                        </el-form-item>
                        <el-form-item prop="vc_pwd" v-show="!isset">
                            <el-input v-model="formlogin.vc_pwd" placeholder="密码" type="password"
                                      prefix-icon="el-icon-lock"></el-input>
                        </el-form-item>
                        <div v-if="isset">
                            <el-form-item>
                                <el-input v-model="formlogin.vc_mobile" placeholder="手机号" disabled></el-input>
                            </el-form-item>
                            <el-form-item class="code">
                                <el-input v-model="formlogin.vc_code" placeholder="验证码" style="width: 48%"></el-input>

                                <el-button type="button" @click="sendsetcode" style="margin: 0 0 0 10px;width: 48%"
                                           :disabled="!show" :class="issend?'disabledbtn':''">
                                    {{btntitle}}
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="commitset()" class="loginbtn">下一步
                                </el-button>
                            </el-form-item>
                        </div>
                        <!-- 登陆拼图 -->
                        <!--<div v-if="flag" class="testCode">
                            <p class="closeBtn">
                                <span class="closetip">完成拼图验证</span>
                                <i class="el-icon-close" @click="flag = !flag" style="padding-right: 10px"></i>
                            </p>
                            &lt;!&ndash;<slide-verify
                                    :l="42"
                                    :r="20"
                                    :w="310"
                                    :h="140"
                                    slider-text="向右拖住滑块填充拼图"
                                    @success="onSuccess"
                                    @fail="onFail"
                                    @refresh="onRefresh"
                                    :style="{ width: '310px' }"
                                    class="slide-box"
                                    ref="slideBlock"
                            ></slide-verify>&ndash;&gt;
                        </div>-->
                        <el-form-item prop="" v-show="!isset">
                            <div style="display: flex;justify-content: flex-end">
                                <div @click="getpwd" style="color: #E89112;width: 70px;cursor: pointer">
                                    忘记密码?
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="" v-show="!isset">
                            <el-button type="primary" @click="oncommit('formlogin')" class="loginbtn">登录
                            </el-button>
                        </el-form-item>
                    </el-form>
                    <!--手机号登录-->
                    <el-form ref="formphone" :model="formphone" :rules="rulesphone" style="padding:35px 0px 20px;"
                             v-show="!temp">
                        <el-form-item prop="vc_mobile">
                            <el-input v-model="formphone.vc_mobile" placeholder="手机号"></el-input>
                        </el-form-item>

                        <el-form-item class="code" prop="vc_code">
                            <el-input v-model="formphone.vc_code" placeholder="验证码" style="width: 48%"></el-input>

                            <el-button type="button" @click="sendcode" style="margin: 0 0 0 10px;width: 48%"
                                       :disabled="!show" :class="issend?'disabledbtn':''">
                                {{btntitle}}
                            </el-button>
                        </el-form-item>
                        <div style="height: 60px"></div>
                        <el-form-item>
                            <el-button type="primary" @click="commitphone('formphone')" class="loginbtn">登录
                            </el-button>
                        </el-form-item>
                    </el-form>


                </div>

            </div>
        </div>

        <div class="footdiv">
            <div>
                <div class="linefoot">网站导航</div>
                <div>企业官网</div>
                <div>电商平台</div>
                <div>使用指南</div>
            </div>
            <div>
                <div class="linefoot" style="width: 90px">联系我们</div>
                <div>咨询电话:4009-288-777</div>
                <div>地址:江苏省南京市建邺区奥体大街69号06栋二,三层</div>
            </div>
            <div>
                <div class="linefoot" style="width: 90px">关注我们</div>

            </div>
        </div>

    </div>
</template>

<script>
    import * as API from "./api";
    import md5 from 'js-md5';

    export default {
        name: 'Home',
        data() {
            return {
                issend: false,
                flag: false,
                temp: true,
                isSuccess: "false",
                disabled:false,
                btntitle: "发送验证码",
                timer: null,
                isset: false,
                dialogFormVisible: false,
                formlogin: {
                    vc_login: "",
                    vc_pwd: "",
                    vc_mobile: "",
                    vc_code: "",
                },
                formphone: {
                    vc_mobile: "",
                    vc_code: "",
                },
                formpwd: {
                    vc_login: '',
                    password: '',
                    verifypwd: '',
                },
                show: true,
                active: true,
                rules: {
                    vc_login: [
                        {required: true, message: '用户名不能为空', trigger: 'blur'},
                    ],
                    vc_pwd: [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                    ],
                },
                rulesphone: {
                    vc_mobile: [
                        {required: true, message: '手机号不能为空', trigger: 'blur'},
                        {
                            type: 'number',
                            message: '手机号格式不正确',
                            trigger: 'blur',
                            transform(value) {
                                var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                                if (!phonereg.test(value)) {
                                    return false
                                } else {
                                    return Number(value)
                                }
                            }
                        }
                    ],
                    vc_code: [
                        {required: true, message: '验证码不能为空', trigger: 'blur'},
                    ],
                }
            }
        },
        watch: {
            isSuccess(val) {
                if (val) {
                    this.getcommit()
                }
            }
        },
        methods: {
            //切换
            change: function (t, formName) {
                this.temp = t;
                this.active = t;
                this.$refs[formName].resetFields();
            },
            touchStartEvent(e) {

            },
            // 拼图成功
            onSuccess() {
                this.isSuccess = true;
                this.flag = false;
            },
            // 拼图失败
            onFail() {
                this.isSuccess = false;
            },
            // 拼图刷新
            onRefresh() {
            },
            getpwd() {
                this.$router.push('./getpassword');
            },
            dialogClose() {
                //移除校验结果并重置字段值
                this.$refs.formpwd.resetFields();
            },
            //帐号登录
            async oncommit(formRef) {
                let valid = this.$formRulesValidate({ref: formRef, example: this});
                if (!valid) {
                    return;
                }
                if (this.formlogin.vc_login === "" || this.formlogin.vc_pwd == "") {
                    this.flag = false;
                } else {
                    this.flag = true;
                    this.getcommit()
                }
            },

            //手机登录
            async commitphone(formRef) {
                this.$refs[formRef].validate(async valid => {
                    if (valid) {
                        let param = {
                            vc_code: this.formphone.vc_code,
                            vc_mobile: this.formphone.vc_mobile,
                            type: 1,
                        };
                        let res = await API.getlogin(param);
                        if (res.code == 1) {
                            this.$message.success(res.message);
                            sessionStorage.setItem("loginuser", res.userName);
                            sessionStorage.setItem("userid", res.userId);
                            sessionStorage.setItem("token", res.token);
                            sessionStorage.setItem("userType", res.userType);
                            this.$router.push('/')
                        } else if (res.code == -13) {
                            this.$confirm(res.message, '友情提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$router.push('/login');
                            })
                        } else {
                            this.$message.error(res.message);
                            this.formphone.vc_code = "";
                        }
                    } else {
                        return false;
                    }
                });
            },
            //验证码校验
            async sendcode() {
                var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
                if (this.formphone.vc_mobile == "") {
                    this.$message.error("手机号不能为空");
                } else if (!reg.test(this.formphone.vc_mobile)) {
                    this.$message.error("手机号码有误，请重填");
                    this.formphone.vc_mobile = ""
                    return false;
                } else {
                    this.getcode();
                    let time = 60;
                    let timer = setInterval(() => {
                        if (time == 0) {
                            clearInterval(timer);
                            this.btntitle = "发送验证码";
                            this.show = true;
                            this.issend = false
                        } else {
                            this.issend = true
                            this.btntitle = time + "秒后重试";
                            time--;
                            this.show = false;
                        }
                    }, 1000)
                }
            },
            //获取验证码
            async getcode() {
                let param = {
                    vc_mobile: this.formphone.vc_mobile,
                    type: 1,
                };
                let res = await API.getcode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.show = false;
                } else {
                    this.$message.error(res.message);
                }
            },

            //登录方法
            async getcommit() {
                const loading = this.$loading({
                    lock: true,
                    text: '登录中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var md = md5(this.formlogin.vc_login + this.formlogin.vc_pwd)
                let param = {
                    vc_login: this.formlogin.vc_login,
                    vc_pwd: md.toUpperCase(),
                };
                let res = await API.getlogin(param);
                if (res.code == 1) {
                    loading.close();
                    this.$message.success(res.message);
                    sessionStorage.setItem("loginuser", res.userName)
                    sessionStorage.setItem("userid", res.userId)
                    sessionStorage.setItem("token", res.token)
                    sessionStorage.setItem("userType", res.userType)
                    this.$router.push('/')
                } else if (res.code == -13) {
                    loading.close();
                    this.$confirm(res.message, '友情提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        this.$router.push('/');
                    })
                    sessionStorage.setItem("loginuser", res.userName)
                    sessionStorage.setItem("userid", res.userId)
                    sessionStorage.setItem("token", res.token)
                    sessionStorage.setItem("userType", res.userType)
                } else if (res.code == 3) {
                    loading.close();
                    this.$confirm(res.message, '友情提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.formpwd.vc_login = this.formlogin.vc_login;
                        this.formlogin.vc_mobile = res.vc_mobile;
                        this.isset = true;
                        this.isSuccess = false;
                        this.disabled=true;
                    }).catch(() => {
                        this.isSuccess = false;
                    })
                } else {
                    loading.close();
                    this.$message.error(res.message);
                    this.flag = false;
                    this.isSuccess = false;
                    this.formlogin = {
                        vc_login: "",
                        vc_pwd: "",
                    }
                }
            },
            //获取验证码
            async sendsetcode() {
                let param = {
                    vc_mobile: this.formlogin.vc_mobile,
                    type: 3,
                };
                let res = await API.getcode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.show = false;
                } else {
                    this.$message.error(res.message);
                }
                let time = 60;
                let timer = setInterval(() => {
                    if (time == 0) {
                        clearInterval(timer);
                        this.btntitle = "发送验证码";
                        this.show = true;
                        this.issend = false
                    } else {
                        this.issend = true
                        this.btntitle = time + "秒后重试";
                        time--;
                        this.show = false;
                    }
                }, 1000)
            },
            //下一步设置密码
            async commitset() {
                if(this.formlogin.vc_code==""){
                    this.$message.error("请填写正确的验证码");
                }else {
                let param = {
                    vc_mobile: this.formlogin.vc_mobile,
                    vc_code: this.formlogin.vc_code,
                    type: 3,
                };
                let res = await API.getvalidatecode(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.dialogFormVisible = true;

                } else {
                    this.$message.error(res.message);
                    this.formlogin.vc_code = "";
                }
                }
            },
            // 设置密码
            async getvalidate(formpwd) {
                var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
                if (this.formpwd.password == "") {
                    this.$message.error("密码不能为空");
                } else if (!regex.test(this.formpwd.password)) {
                    this.$message.error("密码中必须大于6位,包含数字、字母");
                    this.formpwd.password = "";
                    this.formpwd.verifypwd = "";
                } else if (this.formpwd.verifypwd == "") {
                    this.$message.error("确认密码不能为空");
                } else if (this.formpwd.password !== this.formpwd.verifypwd) {
                    this.$message.error("两次密码不一致");
                    this.formpwd.password = "";
                    this.formpwd.verifypwd = "";
                } else {
                    var mdpwd = md5(this.formlogin.vc_login + this.formpwd.password)
                     //console.log(mdpwd)
                    let param = {
                        vc_mobile: this.formlogin.vc_mobile,
                        vc_pwd: mdpwd.toUpperCase(),
                    };
                    let res = await API.setpwd(param);
                    if (res.code == 1) {
                        this.$message.success(res.message);
                        this.isset = false;
                        this.dialogFormVisible = false;
                        this.formlogin.vc_pwd = "";
                        this.disabled=false;
                    } else {
                        this.$message.error(res.message);
                        this.formphone.password = "";
                        this.formpwd.verifypwd = "";
                    }
                }
            },
        },

    }
</script>
<style lang="scss">
    body {
        margin: 0 !important;
    }
    .mainbgm {
        background: url("../../assets/bgm.png");
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;

        .disabledbtn {
            background: #f6f6f6 !important;
            color: #666 !important;
        }

        .active {
            color: #E89112;
            border-bottom: 2px solid;
            font-weight: bold;
        }

        .el-input__icon {
            color: #000;
            font-size: 16px;
        }

        .footdiv {
            display: flex;
            flex: 1;
            justify-content: space-around;
            background: #af7e37;
            opacity: 0.66;
            color: #fff;
            padding: 10px 100px 0 100px;

        }

        .footdiv div {
            font-size: 13px;
            margin: 8px 0;
        }

        .linefoot {
            font-size: 15px !important;
            border-bottom: 1px solid #fff;
            padding-bottom: 4px;
        }

        .loginform {
            width: 310px;
            height: 350px;
            background: #fff;
            padding: 20px 30px;
            background: #fff;
            text-align: center;
            border-radius: 8px;
            box-shadow: 2px 2px 30px lightgray;
        }

        .loginbtn {
            width: 100%;
            color: #fff;
            background: #E89112;
            border-color: #E89112;
        }

        .mainlogin {
            display: flex;
            justify-content: space-around;
            width: 80%;
            margin: 0 auto;
        }

        h2 {
            margin: 130px 0 20px 0;
        }

        h3 {
            margin: 10px 0;
        }

        .usercode {
            padding: 0 0 10px 0;
            width: 40%;
            cursor: pointer;
        }

        .phone {
            width: 40%;
            cursor: pointer;
        }

        .code .el-form-item__content {
            display: flex;
            justify-content: space-between;
        }

        .el-input__inner {
            border-radius: 8px;
        }

        .slide-verify-slider {
            border-radius: 8px;
            background: #e5e4e4 !important;
            margin-top: 10px !important;
        }

        .slide-verify-slider-text {
            font-size: 13px;
            color: #666;
        }

        .slide-verify-slider-mask-item {
            border-radius: 8px;
        }

        .testCode {
            position: absolute;
            top: -35px;
            z-index: 99;
            background: #fff;
            box-shadow: 0 0 2px 2px #eee;
        }

        .closeBtn {
            display: flex;
            justify-content: space-between;
        }

        .closetip {
            font-size: 14px;
            color: #666;
            padding: 0 10px;
        }

        .setform .el-form-item__content {
            margin-left: 0px !important;
        }
    }

</style>
